import React from "react";
import "./StatsRankings.scss";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
// import { Scrollbars } from "react-custom-scrollbars"

function StatsRankings() {
  return (
    <>
      <Header />
      <section className="stats-rankings">
        <div className="exploreCollections">
          <div className="container">
            <div className="section-title">
              <h2>TOP NFTS </h2>
              <p>
                The top NFTs on RedShilliz, ranked by volume, floor price and
                other statistics.
              </p>
            </div>
            <div className="filter-wrap">
              <ul className="filter-list">
                <li>
                  <a href="/" className="active">
                    All Categories
                  </a>
                </li>
                <li>
                  <a href="/">Art</a>
                </li>
                <li>
                  <a href="/">Celebrities</a>
                </li>
                <li>
                  <a href="/">Gaming</a>
                </li>
                <li>
                  <a href="/">Sport</a>
                </li>
                <li>
                  <a href="/">Music</a>
                </li>
                <li>
                  <a href="/">Crypto</a>
                </li>
              </ul>
              <div className="filter-wrap__btns">
                <div className="select-dd">
                  <select>
                    <option value="item1">Last 24 hours</option>
                    <option value="item2">Last 12 hours</option>
                    <option value="item3">Last 5 hours</option>
                    <option value="item4">Last 1 hours</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="filter-list-box-wrap">
              <div className="nft-details__activity w-full">
                <div className="nft-details__activity-table">
                  <table width="100%" cellspacing="7px" cellpadding="0">
                    <thead>
                      <tr>
                        <th width="5px">#</th>
                        <th>Collection</th>
                        <th>Volume</th>
                        <th>24h %</th>
                        <th>7d %</th>
                        <th>Floor Price</th>
                        <th>Owners</th>
                        <th>Items</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            FancyBird #3183{" "}
                            <img
                              className="ml-2"
                              src="../images/svg/checked-badge.svg"
                              alt="eth"
                            />
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td className="green">+101.31%</td>
                        <td className="red">-63.34%</td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>4.6K</td>
                        <td>4.6K</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            FancyBird #3183{" "}
                            <img
                              className="ml-2"
                              src="../images/svg/checked-badge.svg"
                              alt="eth"
                            />
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td className="green">+101.31%</td>
                        <td className="red">-63.34%</td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>4.6K</td>
                        <td>4.6K</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            FancyBird #3183{" "}
                            <img
                              className="ml-2"
                              src="../images/svg/checked-badge.svg"
                              alt="eth"
                            />
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td className="green">+101.31%</td>
                        <td className="red">-63.34%</td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>4.6K</td>
                        <td>4.6K</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            FancyBird #3183{" "}
                            <img
                              className="ml-2"
                              src="../images/svg/checked-badge.svg"
                              alt="eth"
                            />
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td className="green">+101.31%</td>
                        <td className="red">-63.34%</td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>4.6K</td>
                        <td>4.6K</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            FancyBird #3183{" "}
                            <img
                              className="ml-2"
                              src="../images/svg/checked-badge.svg"
                              alt="eth"
                            />
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td className="green">+101.31%</td>
                        <td className="red">-63.34%</td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>4.6K</td>
                        <td>4.6K</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            FancyBird #3183{" "}
                            <img
                              className="ml-2"
                              src="../images/svg/checked-badge.svg"
                              alt="eth"
                            />
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td className="green">+101.31%</td>
                        <td className="red">-63.34%</td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>4.6K</td>
                        <td>4.6K</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            FancyBird #3183{" "}
                            <img
                              className="ml-2"
                              src="../images/svg/checked-badge.svg"
                              alt="eth"
                            />
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td className="green">+101.31%</td>
                        <td className="red">-63.34%</td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>4.6K</td>
                        <td>4.6K</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            FancyBird #3183{" "}
                            <img
                              className="ml-2"
                              src="../images/svg/checked-badge.svg"
                              alt="eth"
                            />
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td className="green">+101.31%</td>
                        <td className="red">-63.34%</td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>4.6K</td>
                        <td>4.6K</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            FancyBird #3183{" "}
                            <img
                              className="ml-2"
                              src="../images/svg/checked-badge.svg"
                              alt="eth"
                            />
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td className="green">+101.31%</td>
                        <td className="red">-63.34%</td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>4.6K</td>
                        <td>4.6K</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* <div className="button-wrap">
              <a href="/" className="button purple-outline">
                Show More
              </a>
            </div> */}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default StatsRankings;
